/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandX = createReactComponent("brand-x", "IconBrandX", [
  ["path", { d: "M4 4l11.733 16h4.267l-11.733 -16z", key: "svg-0" }],
  ["path", { d: "M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772", key: "svg-1" }]
]);

export { IconBrandX as default };
//# sourceMappingURL=IconBrandX.js.map
